import React, { useContext, useEffect, useState } from 'react'
import ReactOTPInput from 'components/common/reactOtpInput'

import './otpStyle.scss'
import { useDispatch, useSelector } from 'react-redux'
import {
    mfaAuthFailed,
    mfaVerify,
    mfaResendCodeFailed,
    resetMFAError,
} from 'modules/authentication/actions'
import { mfaVerifyRegister } from 'modules/user/actions'
import Spinner from 'components/common/spinner'
import ResendButton from './resendButton'
import { LayoutContext } from 'context/LayoutContext'
import { setAgeVerificationRequired } from 'modules/user/actions'
import { util } from 'utils'
// import { RouteConstants } from 'config/routes/routeConstants'
import { useDialog } from 'components/common/modal/Modal'
import { LanguageContext } from '../../context/LanguageContext'
import { isEmpty } from 'utils/appUtils'

const OTP_LENGTH = 6

const EnterOtp = ({ otpData, register = false, signInFromBasket }) => {
    const verifyFn = register ? mfaVerifyRegister : mfaVerify
    const [verifyNumError, setVerifyNumError] = useState(false)
    const [optSuccess, setOtpSuccess] = useState(true)
    const mfaAuthError = useSelector(state => state.authentication.getIn(['mfaAuthError']))

    const mfaResendCodeError = useSelector(state =>
        state.authentication.getIn(['mfaResendCodeError'])
    )
    const { strings } = useContext(LanguageContext)
    const authLoading = useSelector(state => state.authentication.getIn(['authLoading']))
    const { closePanel, panelOpen } = useContext(LayoutContext)
    const loggedIn = useSelector(state => state.authentication.getIn(['loggedIn']))
    const itemsAddedToCart = useSelector(state => state.basket.get('basketItems'))
    const cartItems = itemsAddedToCart?.toJS() || []
    const ageVerification = util.ageVerificationNeeded(cartItems)
    const { on, getToggleProps, toggle } = useDialog()

    const [otp, setOtp] = useState('')

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(resetMFAError())
    }, [])

    useEffect(() => {
        if (signInFromBasket) {
            if (panelOpen) {
                if (loggedIn) {
                    closePanel()
                    if (ageVerification.isNeeded) {
                        dispatch(setAgeVerificationRequired(true))
                        toggle()
                    }
                }
            }
        }
    }, [loggedIn])

    const onVerifyPhoneNumberClick = () => {
        dispatch(mfaAuthFailed(null))
        dispatch(mfaResendCodeFailed(null))
        dispatch(
            verifyFn({
                ...otpData,
                code: otp,
            })
        )
    }

    const onResendOTP = () => {
        dispatch(mfaAuthFailed(null))
        dispatch(mfaResendCodeFailed(null))
        setOtpSuccess(true)
        dispatch(
            verifyFn({
                ...otpData,
                guest_id: undefined,
            })
        )
    }

    const disabled =
        isEmpty(otp) ||
        otp?.length < OTP_LENGTH ||
        authLoading ||
        (mfaAuthError?.data?.error_code && mfaAuthError?.data?.error_code === 423)

    const resendDisabled =
        (mfaAuthError?.data?.error_code && mfaAuthError?.data?.error_code === 423) ||
        (mfaResendCodeError?.data?.error_code && mfaResendCodeError?.data?.error_code === 423)

    return (
        <div className="otp-container">
            {otpData?.is_sms_otp_sent ? (
                <p className="title">
                    {strings.enterOTPFromSMS ||
                        `Please enter the OTP received in the mobile number`}{' '}
                    <b>{otpData?.mobile_number}</b>
                </p>
            ) : (
                <p className="title">
                    {strings.enterOTPMessage ||
                        `Please enter the OTP received in the registered mobile number and email`}
                </p>
            )}

            <div className="ReactInputVerificationCode__container">
                <ReactOTPInput
                    numOfInputs={OTP_LENGTH}
                    setVerifyNumError={setVerifyNumError}
                    setOtp={setOtp}
                />
                <p className="otpErrorMessage">
                    {mfaAuthError?.data?.error_description ||
                        mfaResendCodeError?.data?.error_description ||
                        ''}
                </p>
            </div>

            <div className="buttonContainer">
                {authLoading ? (
                    <Spinner height="3em" width="3em" container={false} />
                ) : (
                    <button
                        className={`btn continueBtn verify_otp  ${disabled && 'disabled'}`}
                        onClick={onVerifyPhoneNumberClick}
                        disabled={disabled}
                    >
                        {strings.verify}
                    </button>
                )}
                <ResendButton
                    getOTPSuccess={optSuccess}
                    onVerifyPhoneNumberClick={onResendOTP}
                    setOtpSuccess={setOtpSuccess}
                    disabled={resendDisabled}
                />
            </div>
        </div>
    )
}

export default EnterOtp
